import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Divider, Typography } from "@mui/material";
import { PriorityHigh } from "@mui/icons-material";

export default function SummaryDialog({ data, onClose = () => {} }) {
  const [openStatus, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  React.useEffect(() => {
    setOpen(data?.open);
    return () => {};
  }, [data]);

  const handleClose = () => {
    onClose();
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        open={openStatus}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent divider>
          <DialogTitle
            component={"h1"}
            id="responsive-dialog-title"
            sx={{
              fontSize: "18px",
              padding: "10px 0px 10px 5px",
              marginBottom: "0px",
              fontWeight: 900,
              display: "flex",
              background: "antiquewhite",
              gap: "10px",
            }}
          >
            <Box
              sx={{
                width: "30px",
                height: "30px",
                backgroundColor: "#f57c00",
                borderRadius: "50%",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PriorityHigh sx={{ color: "white" }} />
            </Box>
            {data?.title}
          </DialogTitle>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ fontSize: "12px" }}
          >
            <Divider sx={{ marginY: "8px" }} />
            <Typography sx={{ marginBottom: "8px" }}>
              {data?.description ?? data?.description}
            </Typography>
            <Box
              sx={{
                minHeight: "180px",
                maxHeight: "240px",
                overflow: "auto",
                overflowX: "hidden",
                background: "#f1f1ee",
              }}
            >
              <ol>
                {data?.lists?.map((elem) => {
                  return <li>{elem}</li>;
                })}
              </ol>
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export const Confirm = ({
  data,
  message,
  open,
  onClose = () => {},
  onLeave = () => {},
  onStay = () => {},
}) => {
  const [openStatus, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleLeave = () => {
    window.close();
    console.log(onLeave);
    onLeave();
    setOpen(false);
  };
  const handleStay = () => {
    onStay();
    setOpen(false);
  };
  React.useEffect(() => {
    setOpen(data?.open);
    return () => {};
  }, [data]);

  const handleClose = () => {
    onClose();
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        open={openStatus}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent divider sx={{ paddingBottom: "5px" }}>
          <DialogTitle
            component={"h1"}
            id="responsive-dialog-title"
            sx={{
              fontSize: "18px",
              padding: "0px 10px 0px 10px",
              marginBottom: "0px",
              fontWeight: 900,
              display: "flex",
              gap: "5px",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: "30px",
                height: "30px",
                backgroundColor: "#f57c00",
                borderRadius: "50%",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PriorityHigh sx={{ color: "white" }} />
            </Box>
            <span>{data?.title}</span>
          </DialogTitle>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ fontSize: "12px" }}
          >
            <Divider sx={{ marginY: "6px", marginBottom: "14px" }} />
            <Typography sx={{ marginBottom: "0px" }}>
              {data?.description ?? data?.description}
            </Typography>
            {data?.lists && (
              <Box
                sx={{
                  minHeight: "180px",
                  maxHeight: "240px",
                  overflow: "auto",
                  overflowX: "hidden",
                  background: "#f1f1ee",
                }}
              >
                <ol>
                  {data?.lists?.map((elem) => {
                    return <li>{elem}</li>;
                  })}
                </ol>
              </Box>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined "
            color="error"
            onClick={handleLeave}
            autoFocus
          >
            Leave
          </Button>
          <Button
            variant="outlined"
            color="success"
            onClick={handleStay}
            autoFocus
          >
            Stay
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
